// extracted by mini-css-extract-plugin
export default {"EmbedCount":"EmbedCount_EmbedCount__G0InS","count":"EmbedCount_count__KGnLn"};